import { MrbBaseRouteStore } from "mrb/core";
import { UserAccountService } from "common/services";

class AppReleaseRouteStore extends MrbBaseRouteStore {
    constructor(rootStore, ServiceType, BetaChannelServiceType) {
        super(rootStore);

        this.service = rootStore.createApplicationService(ServiceType);
        this.betaChannelService = rootStore.createApplicationService(BetaChannelServiceType);
        this.userAccountService = rootStore.createApplicationService(UserAccountService);
    }

    async findVersions(params) {
        const response = await this.service.find(params);
        return response.data;
    }

    async getLatestVersion() {
        const response = await this.service.getLatest();
        return response.data;
    }

    async enableVersion(id) {
        const response = await this.service.enable(id);
        return response.data;
    }

    async disableVersion(id) {
        const response = await this.service.disable(id);
        return response.data;
    }

    async findBetaChannelUsers(params) {
        const response = await this.betaChannelService.find(params);
        return response.data;
    }

    async addBetaChannelUser(userId) {
        const response = await this.betaChannelService.create({ userId });
        return response.data;
    }

    async removeBetaChannelUser(id) {
        const response = await this.betaChannelService.delete({ id });
        return response.data;
    }

    async findUsers(params) {
        const response = await this.userAccountService.find(params);
        return response.data;
    }
}

export default AppReleaseRouteStore;
